resourcePaths = '{"rootPath":"","assetsPath":""}';HTMLElement.prototype.addClass = function(classes) {
  if (!classes) return;
  var s = ("" + classes).split(/\s+/g);
  this.classList.add.apply(this.classList, s);
};

HTMLElement.prototype.removeClass = function(classes) {
  if (!classes) return;
  var s = ("" + classes).split(/\s+/g);
  this.classList.remove.apply(this.classList, s);
};

Element.prototype.querySelectorAllAndSelf = Document.prototype.querySelectorAllAndSelf = function() {
  if (!arguments.length) return this.querySelectorAll();

  var tid = null;
  var pn = this.parentNode;
  var testQuery = arguments[0];
  if (this.doctype) {
    // Duck typing for document object
    pn = this;
  } else if (!pn) {
    pn = document.createElement("div");
    pn.appendChild(this);
  } else {
    // Parent node exists
    if (!this.getAttribute("id")) {
      this.setAttribute("id", "m_frmwk_this_" + new Date().getTime());
      tid = true;
    }

    var queries = testQuery.split(",");
    var arr2 = [];
    for (var i = 0; i < queries.length; i++) {
      arr2.push("#" + this.id + " " + queries[i]);
      queries[i] = queries[i] + "#" + this.id;
    }
    testQuery = queries.join() + ", " + arr2.join();
  }

  var result = pn.querySelectorAll.apply(pn, [testQuery]);
  if (tid) this.removeAttribute("id");
  //testResults(result, $(arguments[0], this).andSelf().filter(arguments[0]), arguments[0]);
  return result;
};

function testJquery() {
  var list = $("div");
  var listUpdated = [];
  for (var i = 0; i < list.length; i++) {
    listUpdated[i] = list[i];
  }

  console.time("selectorAndSelf_jquery");
  for (var j = 0; j < 100; j++) {
    for (var i = 0; i < listUpdated.length; i++) {
      var a = $(listUpdated[i]).find("[data-mogo-ui],[data-mogo-page]").addBack("[data-mogo-ui],[data-mogo-page]");
    }
  }
  console.timeEnd("selectorAndSelf_jquery");
}

function testNative() {
  var list = $("div");
  var listUpdated = [];
  for (var i = 0; i < list.length; i++) {
    listUpdated[i] = list[i];
  }

  console.time("selectorAndSelf_native");
  for (var j = 0; j < 100; j++) {
    for (var i = 0; i < listUpdated.length; i++) {
      var a = listUpdated[i].querySelectorAllAndSelf("[data-mogo-ui],[data-mogo-page]");
    }
  }
  console.timeEnd("selectorAndSelf_native");
}

// function testResults(a, b, params) {
//   if (a.length != b.length) {
//     console.log(params);
//     throw "Unequal size";
//   } else {
//     for (var i = 0; i < a.length; i++) {
//       if (a[i] != b[i]) {
//         console.log(params);
//         throw "Different results;";
//       }
//     }
//   }
//   console.log("passed");
// }
